export default {"src":"/_next/static/media/sign_in.7d4ec0af.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};